'use strict';

function PositionUtil ($document, $window) {

  /**
   * Calculate the element rectangle of a DOM node given a desired position and alignment
   *
   * @param  {Object} element   Angular jqLite wrapper DOM node
   * @param  {Array}  position  [x,y] position
   * @param  {Object} alignment {x: left|center|right, y: top|center|bottom}
   * @return {Object} element bounding box
   */
  this.getElementRectangle = function (element, position, alignment) {
    var x = position[0];
    var y = position[1];
    var node = element[0];
    var height = node.offsetHeight || 0;
    var width = node.offsetWidth || 0;

    // default alignment is "top left"
    alignment = alignment || {x: 'left', y: 'top'};

    var shiftWidth = {
      center: -(width / 2),
      left: 0,
      right: -width
    };

    var shiftHeight = {
      center: -(height / 2),
      top: 0,
      bottom: -height
    };

    function getLeft (alignment) {
      return x + shiftWidth[alignment.x];
    }

    function getRight (alignment) {
      return getLeft(alignment) + width;
    }

    function getTop (alignment) {
      return y + shiftHeight[alignment.y];
    }

    function getBottom (alignment) {
      return getTop(alignment) + height;
    }

    return {
      bottom: getBottom(alignment),
      left: getLeft(alignment),
      right: getRight(alignment),
      top: getTop(alignment)
    };
  };

  /**
   * Returns the first non-statically positioned parent of a given element
   *
   * @param  {Object} element Angular jqList wrapped DOM element
   * @return {Object} DOM node
   */
  this.getParentOffsetNode = function (element) {
    var docDomEl = $document[0].body;
    var offsetParent = element[0].offsetParent || element[0].parentElement;

    while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {
      offsetParent = offsetParent.offsetParent || offsetParent.parentElement;
    }

    return offsetParent || docDomEl;
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  /////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Get the css styles of a given element
   *
   * @param  {Object} el raw DOM node
   * @param  {String} cssprop CSS attribute to retrieve
   * @return {String} css property
   */
  function getStyle (el, cssprop) {
    if (el.currentStyle) { //IE
      return el.currentStyle[cssprop];
    } else if ($window.getComputedStyle) {
      return $window.getComputedStyle(el)[cssprop];
    }
    // finally try and get inline style
    return el.style[cssprop];
  }

  /**
   * Checks if a given element is statically positioned
   *
   * @param {Object} element raw DOM node
   */
  function isStaticPositioned(element) {
    return ((getStyle(element, 'position') || 'static' ) === 'static') || angular.element(element).hasClass('skip-static-check');
  }
}

module.exports = PositionUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/utils/src/PositionUtil.js